import { resetExamStatistics } from '../../../store/workspace/slice';
import { useDispatch } from '../../../store/store';
import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';

/**
 * Layout route of the job history section. It owns nothing but the lifetime of
 * the exam statistics slice — every screen below renders its own skeletons.
 */
function JobsHistory() {
    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            dispatch(resetExamStatistics());
        };
    }, [dispatch]);

    return <Outlet />;
};

export default JobsHistory;
